import { render, staticRenderFns } from "./fourinfo.vue?vue&type=template&id=2e820335&scoped=true&"
import script from "./fourinfo.vue?vue&type=script&lang=js&"
export * from "./fourinfo.vue?vue&type=script&lang=js&"
import style0 from "./fourinfo.vue?vue&type=style&index=0&id=2e820335&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e820335",
  null
  
)

export default component.exports